export enum ColorMapOption {

  // Diverging
  interpolateBrBG = 'interpolateBrBG',
  interpolatePRGn = 'interpolatePRGn',
  interpolatePiYG = 'interpolatePiYG',
  interpolatePuOr = 'interpolatePuOr',
  interpolateRdBu = 'interpolateRdBu',
  interpolateRdGy = 'interpolateRdGy',
  interpolateRdYlBu = 'interpolateRdYlBu',
  interpolateRdYlGn = 'interpolateRdYlGn',
  interpolateSpectral = 'interpolateSpectral',

  // Single Hue
  interpolateBlues = 'interpolateBlues',
  interpolateGreens = 'interpolateGreens',
  interpolateGreys = 'interpolateGreys',
  interpolateOranges = 'interpolateOranges',
  interpolatePurples = 'interpolatePurples',
  interpolateReds = 'interpolateReds',


  // Multi Hue
  interpolateTurbo = 'interpolateTurbo',
  interpolateViridis = 'interpolateViridis',
  interpolateInferno = 'interpolateInferno',
  interpolateMagma = 'interpolateMagma',
  interpolatePlasma = 'interpolatePlasma',
  interpolateCividis = 'interpolateCividis',
  interpolateWarm = 'interpolateWarm',
  interpolateCool = 'interpolateCool',
  interpolateCubehelixDefault = 'interpolateCubehelixDefault',
  interpolateBuGn = 'interpolateBuGn',
  interpolateBuPu = 'interpolateBuPu',
  interpolateGnBu = 'interpolateGnBu',
  interpolateOrRd = 'interpolateOrRd',
  interpolatePuBuGn = 'interpolatePuBuGn',
  interpolatePuBu = 'interpolatePuBu',
  interpolatePuRd = 'interpolatePuRd',
  interpolateRdPu = 'interpolateRdPu',
  interpolateYlGnBu = 'interpolateYlGnBu',
  interpolateYlGn = 'interpolateYlGn',
  interpolateYlOrBr = 'interpolateYlOrBr',
  interpolateYlOrRd = 'interpolateYlOrRd',

  // Cyclical
  interpolateRainbow = 'interpolateRainbow',
  interpolateSinebow = 'interpolateSinebow',
}
